import React, {Component} from 'react';

export default class DisplaySuggestions extends Component {
  render(){
    return (
      <div className='suggestions-container'>
              <h4>Things you can try –</h4>
              <ul className="suggestions-list">
                <li className="tip shower">Shower for less time</li>
                <li className="tip light">Install LEDs</li>
                <li className="tip bags">Use reusable bags</li>
              </ul>
              
      </div>
    )
  }
}
